import React from "react";
import { useReactFlow } from "reactflow";
import { ZoomInOutlined, ZoomOutOutlined, ExpandOutlined } from "@ant-design/icons";
import { WORKFLOW_CANVAS_FIT_VIEW_OPTIONS } from "../constants/workflowConstants";

export const WorkflowCustomControls: React.FC = () => {
    const { fitView, zoomIn, zoomOut } = useReactFlow();

    return (
        <div
            className="workflow-custom-controls d-flex flex-column gap-1 cursor-pointer hs-bg-light-grey-1 hs-border-light rounded-3 hs-bg-white cursor-pointer"
            role="group"
            aria-label="Canvas zoom and fit controls"
        >
            <button
                type="button"
                onClick={() => zoomIn()}
                className="workflow-custom-controls-btn d-flex align-items-center justify-content-center hs-color-BlackRussian"
                aria-label="Zoom in"
                title="Zoom in"
            >
                <ZoomInOutlined />
            </button>
            <button
                type="button"
                onClick={() => zoomOut()}
                className="workflow-custom-controls-btn d-flex align-items-center justify-content-center hs-color-BlackRussian"
                aria-label="Zoom out"
                title="Zoom out"
            >
                <ZoomOutOutlined />
            </button>
            <button
                type="button"
                onClick={() => {
                    requestAnimationFrame(() => fitView(WORKFLOW_CANVAS_FIT_VIEW_OPTIONS));
                }}
                className="workflow-custom-controls-btn d-flex align-items-center justify-content-center hs-color-BlackRussian"
                aria-label="Fit view"
                title="Fit to view"
            >
                <ExpandOutlined />
            </button>
        </div>
    );
};
